import React from 'react';

type Props = {
  link: string;
  text: string;
};

const CustomLink = ({ link, text }: Props): JSX.Element => (
  <a href={link} data-testid="CustomLink" target="_blank" rel="noopener noreferrer" data-text={text}>
    {text}
  </a>
);

export default CustomLink;
